import { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, Search } from "lucide-react";
import { CTA, PageHero, Reveal, useSeo } from "../components/Shared";
import { ARTICLES } from "../data/content";

const CATS = ["All", ...new Set(ARTICLES.map((a) => a.cat))];

export default function Insights() {
  useSeo(
    "Insights | Dishan International Group",
    "Perspectives on business, brands, leadership, careers, wellbeing and change, from the Dishan knowledge desk."
  );
  const [filter, setFilter] = useState("All");
  const [q, setQ] = useState("");
  const list = ARTICLES.filter((a) => (filter === "All" || a.cat === filter) && (q === "" || a.title.toLowerCase().includes(q.toLowerCase())));

  return (
    <>
      <PageHero
        eyebrow="Insights"
        titleKey="insights.hero.title" title="Ideas with somewhere to go."
        subtitleKey="insights.hero.subtitle" subtitle="Perspectives from the Dishan ecosystem on business, brands, leadership, careers, wellbeing and change."
      />
      <main>
        <section className="section">
          <div className="container">
            <div className="insights-toolbar">
              <div className="filters">
                {CATS.map((c) => (
                  <button className={filter === c ? "selected" : ""} onClick={() => setFilter(c)} key={c} data-testid={`insights-filter-${c.toLowerCase()}`}>{c}</button>
                ))}
              </div>
              <div className="search-box">
                <Search size={15} />
                <input placeholder="Search insights" aria-label="Search insights" value={q} onChange={(e) => setQ(e.target.value)} data-testid="insights-search-input" />
              </div>
            </div>
            <div className="article-grid">
              {list.map((a, i) => (
                <Reveal key={a.slug} delay={(i % 3) * 0.06}>
                  <Link to={`/insights/${a.slug}`} className="insight-card" data-testid={`article-card-${i + 1}`}>
                    <div className="insight-media"><img src={a.img} alt={a.title} loading="lazy" /></div>
                    <div className="insight-body">
                      <span className="tag">{a.cat}</span>
                      <h3>{a.title}</h3>
                      <p>{a.excerpt}</p>
                      <span className="insight-date">{a.date} · {a.read} <ArrowUpRight size={14} /></span>
                    </div>
                  </Link>
                </Reveal>
              ))}
              {list.length === 0 && <p className="empty-note" data-testid="insights-empty-message">No insights match your search just yet.</p>}
            </div>
          </div>
        </section>
        <CTA />
      </main>
    </>
  );
}
